export default __webpack_public_path__ + "72e3298d14ecaadb2cd951a7b5acee23.png";